import { render } from "./ListaResponsaveisEncerramento.vue?vue&type=template&id=685f0140&scoped=true"
import script from "./ListaResponsaveisEncerramento.vue?vue&type=script&lang=js"
export * from "./ListaResponsaveisEncerramento.vue?vue&type=script&lang=js"

import "./ListaResponsaveisEncerramento.vue?vue&type=style&index=0&id=685f0140&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-685f0140"]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QImg,QBtn,QTooltip,QSpinner,QCardSection});
